import React from 'react';
import Swimlane from 'web-ui-kit/ProductDetails/components/Swimlane';

function SimilarProducts(_ref) {
  var _ref$dispatch = _ref.dispatch,
      dispatch = _ref$dispatch === void 0 ? function () {} : _ref$dispatch,
      _ref$productDetailsSt = _ref.productDetailsState,
      productDetailsState = _ref$productDetailsSt === void 0 ? {} : _ref$productDetailsSt,
      _ref$scrollToTop = _ref.scrollToTop,
      scrollToTop = _ref$scrollToTop === void 0 ? function () {} : _ref$scrollToTop;
  var product = productDetailsState.product,
      similarProducts = productDetailsState.similarProducts,
      similarProductsLoading = productDetailsState.similarProductsLoading,
      swapStatus = productDetailsState.swapStatus; // We only show the similar products section
  // when we have products to show.

  var showSimilarProducts = !!product && !similarProductsLoading && similarProducts.length > 1; // Early exit if there is nothing to render.

  if (!showSimilarProducts) {
    return null;
  }

  return (
    /*#__PURE__*/
    React.createElement(Swimlane, {
      heading: 'Similar products',
      id: "similar-products",
      dispatch: dispatch,
      parentProduct: product,
      products: similarProducts,
      scrollToTop: scrollToTop,
      swapStatus: swapStatus
    })
  );
}

export default SimilarProducts;